module.exports = __webpack_public_path__ + "static/media/hot.785e812c.svg";